import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Flex from '../../Flex';
import { Button, Icon } from 'antd';
import style from './index.css';

export default class _siderMenu extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        extra: PropTypes.bool,
        onEdit: PropTypes.func,
        onSave: PropTypes.func,
        onClose: PropTypes.func,
        onApplyClick: PropTypes.func,
    };

    static defaultProps = {
        extra: true,
        onEdit: Function.prototype,
        onSave: Function.prototype,
        onClose: Function.prototype,
        onApplyClick: Function.prototype,
    };

    state = {
        edit: false
    };

    render() {
        const {
            className,
            children,
            apply,
            title,
            extra,
            onEdit,
            onSave,
            onClose,
            onApplyClick
        } = this.props;
        const { edit } = this.state;

        return (
            <Flex className={className} className={style.title_top} justify="between">
                <div className={style.title_top_name}>{title}</div>
                <Flex.Item  className={style.line}/>
                {extra && (
                    <div>
                        <Button
                            className="ml-10"
                            className={style.ml_10}
                            type="primary"
                            ghost
                            onClick={() => {
                                edit ? onSave(title) : onEdit(title);
                                this.setState({
                                    edit: !edit
                                });
                            }}
                        >
                            {edit ? '保存' : '编辑'}
                        </Button>
                        {edit && (

                            <Button
                            className="ml-10"
                            className={style.ml_10}
                            type='ghost'
                            onClick={() => {
                                this.setState({
                                    edit: false
                                });
                                onClose(title);
                            }}
                        >
                            {'取消'}
                        </Button>
                        )}
                    </div>
                )}
                {apply && (
                    <Button
                        className="ml-10"
                        className={style.ml_10}
                        type="primary"
                        ghost
                        onClick={() => {
                            onApplyClick();
                        }}
                    >
                        申请
                    </Button>
                )}
                {children}
            </Flex>
        );
    }
}



// WEBPACK FOOTER //
// ./components/yxxc/print/Assembly/titleTop/index.js